import { EntityReport4det } from "../../entity/EntityReport4det";

export class DtoReport4detsPostRes extends EntityReport4det {}
